export default function Marquee({ light = false }) {
  const items = [
    "TRANSPARENCIA",
    "COMPROMISO SOCIAL",
    "OBRAS DE IMPACTO",
    "RESULTADOS PARA TAMPICO",
    "VERIFICACIÓN CIUDADANA",
    "SEGUNDO INFORME DE GOBIERNO",
  ];
  const row = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className={`overflow-hidden border-y select-none ${
        light ? "border-white/10 bg-guinda-dark" : "border-border bg-arena-light"
      }`}
    >
      <div className="flex w-max animate-marquee py-4">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className={`flex items-center font-serif italic text-lg sm:text-xl tracking-wide whitespace-nowrap ${
                  light ? "text-arena/80" : "text-gris/70"
                }`}
              >
                {item}
                <span className={`mx-8 text-sm not-italic ${light ? "text-guinda-light" : "text-guinda"}`}>✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
